import { GeneralModel } from "./general.model";
import { AreaGroup } from "./areaGroup.model";
import { District } from "./district.model";
import { Province } from "./province.model";

export class Area extends GeneralModel {
    areaGroupId: number;
    areaGroup: AreaGroup;
    districtIds: number[];
    district: District;
    province: Province;
    
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/models/area.model.ts